const consumptionLocale = {
  consumption: {
    consumptions: "Consommation",
  },
};

export type ConsumptionLocale = typeof consumptionLocale;
export default consumptionLocale;
